// extracted by mini-css-extract-plugin
export default {"productTitle":"ProductControlContent_productTitle__REOoR","iconInfoContainer":"ProductControlContent_iconInfoContainer__+QM-0","close":"ProductControlContent_close__DFR-d"};